import request from "../../utils/request";

export const aliOauth = (params) =>
  request(
    "storemarketing/Selfpurchase/orderQrcodeSelfpurchase",
    "post",
    params
  );


export const notify = (params) =>
  request(
    "storemarketing/Selfpurchase/orderQrcodeSelfpurchase",
    "post",
    params
  );

// 通过商户号获取信息
export const getToken = (params) =>
    request(
        "payments/fupay/getinfobymtoken",
        "post",
        params
    );